import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const CopyIcon = ({
  width = 24,
  height = 24,
  stroke = '#A0A4A8',
  strokeWidth = 2,
}: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M20 9h-9c-1.105 0-2 .895-2 2v9c0 1.105.895 2 2 2h9c1.105 0 2-.895 2-2v-9c0-1.105-.895-2-2-2z"
    />
    <path
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={strokeWidth}
      d="M5 15H4c-.53 0-1.04-.21-1.414-.586C2.21 14.04 2 13.53 2 13V4c0-.53.21-1.04.586-1.414C2.96 2.21 3.47 2 4 2h9c.53 0 1.04.21 1.414.586C14.79 2.96 15 3.47 15 4v1"
    />
  </svg>
);
